import React from 'react';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import {
    SlideContainer, SlideTitle, SlideSubtitle, SlideText, BulletList, BulletItem, HighlightBox, IconCircle,
    welcomeSlide, historicSlide, finalSlide,
} from 'components/v3/onboarding/OnboardingSlideElements';

// ==========================================
// Profil REGION — group-manager
// Atterrissage : /my-region. Voit Ma région + Historique + Membres (peut inviter des
// responsables magasin/entrepot, pas les roles egaux ou superieurs).
// ==========================================

export const regionSlides = () => [
    welcomeSlide(
        "Votre espace s'articule autour de « Ma région », qui compare vos magasins entre eux, et de « Historique », qui garde la trace de tous les scans.",
    ),

    {
        title: '1 · Ma région',
        content: (
            <SlideContainer>
                <SlideTitle>
                    <IconCircle><MapOutlinedIcon /></IconCircle>
                    1 · Ma région
                </SlideTitle>
                <SlideText>
                    Votre page d'accueil : la situation de <strong>tous les magasins dont vous avez la charge</strong>,
                    d'un coup d'œil. Si vous suivez plusieurs régions, un sélecteur en haut de page permet de passer
                    de l'un à l'autre.
                </SlideText>

                <SlideSubtitle>La synthèse</SlideSubtitle>
                <BulletList>
                    <BulletItem>
                        <strong>Magasins</strong> — le nombre de magasins de la région.
                    </BulletItem>
                    <BulletItem>
                        <strong>Vides à retourner</strong> — le total des emballages vides en magasins dans toute la région.
                    </BulletItem>
                    <BulletItem>
                        <strong>Stock dormant</strong> — la part des emballages en magasins qui ne bougent plus, au-delà du nombre de
                        jours que vous avez fixé. C'est votre principal signal d'alerte : du stock immobilisé, c'est du
                        stock qui manque ailleurs.
                    </BulletItem>
                    <BulletItem>
                        <strong>Master Contenant</strong> — la capacité retenue pour les bacs de collecte d'emballage vide en magasins. Quand un bac approche du plein, c'est le moment de préparer l'enlèvement.
                    </BulletItem>
                    <BulletItem>
                        <strong>Pleins en attente</strong> — donnée indisponible pour le moment, nécessite une connexion aux transporteurs.
                    </BulletItem>
                </BulletList>

                <SlideSubtitle>Le détail opérationnel</SlideSubtitle>
                <SlideText>
                    Le tableau du bas reprend chaque magasin ligne par ligne (vides, remplissage du bac, âge moyen du stock
                    dans chaque magasin).
                    <strong> Cliquez sur une ligne</strong> pour ouvrir le panneau détaillé du magasin.
                </SlideText>

                <HighlightBox>
                    <SlideText sx={{ marginBottom: 0 }}>
                        ✏️ Le seuil du stock dormant et la capacité du Master Contenant peuvent se régler avec les petits crayons.
                    </SlideText>
                </HighlightBox>
            </SlideContainer>
        ),
    },

    historicSlide(2, false),

    // Paramètres
    {
        title: '3 · Ajouter des membres et gérer les accès',
        content: (
            <SlideContainer>
                <SlideTitle>
                    <IconCircle><SettingsIcon /></IconCircle>
                   3 · Ajouter des membres et gérer les accès
                </SlideTitle>
                <SlideText>
                    Dans les paramètres deux pages vous sont ouvertes ici : <strong>Membres</strong>, pour gérer les accès à votre
                    périmètre, et <strong>Mon compte</strong>, pour vos informations personnelles.
                </SlideText>

                <SlideSubtitle>Membres</SlideSubtitle>
                <BulletList>
                    <BulletItem>
                        Vous pouvez <strong>inviter de nouveaux membres</strong> et leur attribuer le rôle{' '}
                        <strong>Responsable magasin</strong> ou <strong>Responsable entrepôt</strong>, en les
                        rattachant au choix aux lieux présents dans votre région.
                    </BulletItem>
                </BulletList>

                <HighlightBox>
                    <SlideText sx={{ marginBottom: 0 }}>
                        💡 Le rôle attribué détermine ce que la personne peut voir : un Responsable magasin
                        n'aura accès qu'aux données de son magasin, un Responsable entrepôt qu'aux données de son entrepôt.
                    </SlideText>
                </HighlightBox>
            </SlideContainer>
        ),
    },

    finalSlide(),
];
